import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

import './_tag.scss';

const Tag = ({ children, onClick }) => {
  if (onClick) return  <Button className="tag button" onClick={onClick}>{ children }</Button>;
  return <div className="tag">{ children }</div>;
};

Tag.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func
};

export default Tag;
